
const RoleGuard = ({ allowedRoles, children }) => {
  const sessionData = JSON.parse(sessionStorage.getItem("user") || "null");
  const userRole = sessionData?.role;

  if (!sessionData || !allowedRoles.includes(userRole)) {
    return null; // Hide the component for unauthorized roles
  }

  return children;
};

export default RoleGuard;